import { useState } from 'react';

const RenameWidgetModal = ({ isOpen, onClose, currentName, onSave }) => {
    const [widgetName, setWidgetName] = useState(currentName || '');

    const handleSave = () => {
        if (widgetName.trim()) {
            onSave(widgetName.trim());
            onClose();
        }
    };

    const handleCancel = () => {
        setWidgetName(currentName || '');
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">Rename Widget</h2>

                <div className="mb-4">
                    <label htmlFor="widget-name" className="block text-sm font-medium text-gray-700 mb-2">
                        Widget Name
                    </label>
                    <input
                        id="widget-name"
                        type="text"
                        value={widgetName}
                        onChange={(e) => setWidgetName(e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                        placeholder="Enter widget name"
                        autoFocus
                    />
                </div>

                <div className="flex space-x-3">
                    <button
                        onClick={handleCancel}
                        className="flex-1 px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSave}
                        disabled={!widgetName.trim()}
                        className="flex-1 px-4 py-2 bg-black hover:bg-gray-800 disabled:bg-gray-400 disabled:cursor-not-allowed text-white rounded-lg font-medium transition-colors"
                    >
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RenameWidgetModal; 